import classes from 'components/Spinner/Spinner.module.scss';
export default function Loading() {
  return <div className={classes.ldsDualRing} />;
}
